import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { DataGrid } from "@material-ui/data-grid";
import { Button, Modal, Form, InputGroup } from "react-bootstrap";
import SearchIcon from "@material-ui/icons/Search";
import { Paper, Grid, FormControl, Select, InputLabel, MenuItem, makeStyles } from "@material-ui/core";
import GatherBillableDetail from "../../../components/GatherBillableDetail";
import * as Admin from "../../../store/ducks/admin.duck";
import { ToastContainer, Flip } from "react-toastify";
// import { saveAs } from 'file-saver';
import "react-toastify/dist/ReactToastify.css";

// Need to rewrite this - as it is not completely correct
// In the world of confusion - please note the following invoicing process
//
// Today we are billing per booking using the Services Table to define the prices - each booking has a billable type that is set (or defaulted) when a booking is made
//
// Process
//
// GatherBillable.js  - Lists providers (including client list) to be billed as at the end of the previous month (this may need to be configurable).
//                    - Only list bookings that have a booking charged field of null and a booking of status Active
//                    - Gives user option to email providers a list of those to be billed at the end of the month if still eliglible.
//                    - Can toogle bookings to cancelled/noshow as needed
// Invoices.js        - Lists providers (including client list) to be billed as at the end of the previous month (this may need to be configurable).
//                    - Only list bookings that have a booking charged field of null and a booking of status Active
//                    - Gives user option to create Invoices in Xero for these providers.
//                    - This essentially a copy of GatherBillable though expect this will change at client acceptance occurs.
// InvoiceLog.js      - This is a searchable log of invoices/clients/providers
//
// PlatformPsychologist.js - Lists unbilled boookings
//                         - Only list bookings that have a booking charged field of null and a booking of status Active
//                         - Can toogle bookings to cancelled/noshow as needed //

const useStyles = makeStyles((theme) => ({
  noBorder: {
    border: "none",
  },
  formControl: {
    margin: 0, //theme.spacing(1),
    minWidth: 120,
  },
  formControlWide: {
    margin: 0, //theme.spacing(1),
    minWidth: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  label: {
    backgroundColor: "#fff",
    paddingLeft: 3,
    paddingRight: 3,
  },
}));

const useStylesDatePicker = makeStyles({
  root: {
    "& .MuiInputBase-root": {
      height: 33,
    },
  },
});

export default function GatherBillableNthQLDPHN() {
  const dispatch = useDispatch();
  const classes = useStyles();
  const classesDatePicker = useStylesDatePicker();

  const billableIntents = useSelector((state) => state.admin.BillableIntentNthQLDPHN);
  const filters = useSelector((state) => state.admin.Filters);
  // const bookingBillableCSV = useSelector(state => state.admin.BookingBillableCSV);
  // const [exportExcelStatus, setExportExcelStatus] = useState('Not Started')
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    dispatch(Admin.actions.fetchBillableIntentsNthQLDPHN({ startDate: filters.invoiceStartDate, endDate: filters.invoiceEndDate }));
  }, [dispatch, filters.invoiceStartDate, filters.invoiceEndDate]);

  const searchBillableIntents = (billableIntent) => {
    if (
      true &&
      ((billableIntent) => billableIntent.psychologistName.toLowerCase().search(searchTerm.toLowerCase()) > -1 || searchTerm.length === 0) &&
      (!filters.invoiceStatus ||
        filters.invoiceStatus === "All" ||
        billableIntent.billingstatus === filters.invoiceStatus ||
        billableIntent.billingstatus === "Multiple")
    ) {
      return billableIntent;
    }
  };

  const filteredbillableIntents = billableIntents.filter((billableIntent) => searchBillableIntents(billableIntent));
  const [showClients, setShowClients] = useState(false);
  const [providerClients, setProviderClients] = useState();
  const [psychologistID, setPsychologistID] = useState();
  const [providerName, setProviderName] = useState();

  // initial call from the download button - fires fetch action if needed, otherwise triggers download
  // const exportFile = () => {
  //   if(exportExcelStatus === 'Not Started')
  //   {
  //     dispatch(Admin.actions.fetchBookingBillableCSV({ startDate: filters.invoiceStartDate, endDate: filters.invoiceEndDate, billableStatus: filters.invoiceStatus}))
  //     setExportExcelStatus('Fetching')
  //   }
  // }

  // grab the blob from state and tell the browser to download
  // const downloadExport = () => {
  //   // Sort out filename
  //   let headingStartDate = '';
  //   let headingEndDate = '';
  //   let headingStatus = '';
  //   //
  //   if (filters.invoiceStartDate === '')
  //   {
  //     headingStartDate = '2020-01-01'
  //   }
  //   else
  //   {
  //     headingStartDate = filters.invoiceStartDate;
  //   }
  //   if (filters.invoiceEndDate === '')
  //   {
  //     let yourDate = new Date();
  //     headingEndDate = yourDate.toISOString().split('T')[0];
  //     console.log(headingEndDate);
  //   }
  //   else
  //   {
  //     headingEndDate = filters.invoiceEndDate;
  //   }
  //   if (filters.invoiceStatus === 'All')
  //   {
  //     headingStatus = '';
  //   }
  //   else
  //   {
  //     if (filters.invoiceStatus === 'Unbilled')
  //     {
  //       headingStatus = '-Unbilled Bookings';
  //     }
  //     else
  //     {
  //       headingStatus = '-Billed Bookings';
  //     }
  //   }
  //   //
  //   var exportDocName = 'RHC-Bookings- FROM-' + headingStartDate + '-TO-' + headingEndDate  + headingStatus;
  //   if(bookingBillableCSV && bookingBillableCSV !== '')
  //   {
  //     const file = new Blob(
  //     [Buffer.from(bookingBillableCSV)],
  //     {type: 'text/csv'});
  //     saveAs(file, `${exportDocName}.csv`);
  //   }
  // }

  // useEffect to fire when status is 'Fetching' and we get the result in redux
  // useEffect( () => {
  //   if(exportExcelStatus === 'Fetching' && bookingBillableCSV && bookingBillableCSV !== '')
  //   {
  //     downloadExport()
  //     setExportExcelStatus('Not Started')
  //   }
  // }, [exportExcelStatus, bookingBillableCSV,downloadExport])

  // function sendProviderEmail()
  // {
  //   if (process.env.REACT_APP_DEBUG)
  //   {
  //     console.log ('Generating Billable Client Emails to Psychologists');
  //   }
  //   dispatch(Admin.actions.putCreateProviderBillableEmails());
  // }

  const loadClients = (thisPsychologist) => {
    setProviderName(thisPsychologist.psychologistName);
    setProviderClients(thisPsychologist.clients);
    setPsychologistID(thisPsychologist.id);
    setShowClients(true);
  };

  const columns = [
    { field: "id", headerName: "ID", width: 100, hide: true },
    { field: "psychologistSurname", headerName: "psychologistSurname", width: 100, hide: true },
    {
      field: "psychologistName",
      headerName: "Name",
      width: 300,
      renderCell: (params) => (
        <strong>
          <div onClick={() => loadClients(billableIntents.find((intent) => intent.psychologistName === params.row.psychologistName))} className="cell-Link">
            {params.value}
          </div>
        </strong>
      ),
    },
    { field: "psychologistEmail", headerName: "Email", width: 300 },
    { field: "xero", headerName: "Xero Link", width: 200 },
    { field: "totalClients", headerName: "Bookings", width: 200 },
    { field: "total", headerName: "Total", width: 120 },
    { field: "billingstatus", headerName: "Billing Status", width: 150 },
  ];

  function handleClientsClose() {
    setShowClients(false);
  }

  const handleSearch = (event) => {
    const searchTerm = event.target.value;
    setSearchTerm(searchTerm);
  };

  return (
    <>
      <Grid container direction="row" justifyContent="space-between">
        <Grid item>
          <h4 style={{ marginBottom: 12 }}>Review Contract Bookings</h4>
        </Grid>
      </Grid>

      <Paper>
        <Grid container style={{ padding: 10 }}>
          <Grid item style={{ paddingLeft: 2, paddingRight: 10 }}>
            {/* <Grid item style={{ marginTop: 2, marginLeft: 10 }}> */}
            <InputGroup size="sm">
              <InputGroup.Prepend>
                <InputGroup.Text>
                  <SearchIcon fontSize="small" style={{ marginLeft: -4 }} />
                </InputGroup.Text>
              </InputGroup.Prepend>
              <Form.Control type="text" value={searchTerm} onChange={(event) => handleSearch(event)} autoComplete="OFF" style={{ height: 33 }} />
            </InputGroup>
          </Grid>
          <Grid item style={{ paddingRight: 10 }}>
            <FormControl variant="outlined" className={classes.formControl} size="small">
              <InputLabel id="invoiceStatus-label" className={classes.label}>
                {" "}
                Invoice Status
              </InputLabel>
              <Select
                labelId="InvoiceStatus-label"
                id="InvoiceStatus"
                margin="dense"
                style={{ minWidth: 120, backgroundColor: "#ffffff", height: 33 }}
                value={filters.invoiceStatus}
                onChange={(event) => dispatch(Admin.actions.setFilters({ filterName: "invoiceStatus", filterValue: event.target.value }))}
              >
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="Billed">Billed</MenuItem>
                <MenuItem value="Unbilled">UnBilled</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item style={{ marginLeft: 10, display: "flex", alignItems: "center" }}>
            <span style={{ marginRight: 5, fontSize: 13 }}>Start:</span>
            <Form.Control
              type="date"
              id="invoiceStartDate"
              name="invoiceStartDate"
              value={filters.invoiceStartDate || ""}
              onChange={(e) =>
                dispatch(
                  Admin.actions.setFilters({
                    filterName: "invoiceStartDate",
                    filterValue: e.target.value,
                  }),
                )
              }
              style={{ maxWidth: 140, height: 35 }}
            />
          </Grid>
          <Grid item style={{ marginLeft: 10, display: "flex", alignItems: "center" }}>
            <span style={{ marginRight: 5, fontSize: 13 }}>End:</span>
            <Form.Control
              type="date"
              id="invoiceEndDate"
              name="invoiceEndDate"
              value={filters.invoiceEndDate || ""}
              onChange={(e) =>
                dispatch(
                  Admin.actions.setFilters({
                    filterName: "invoiceEndDate",
                    filterValue: e.target.value,
                  }),
                )
              }
              style={{ maxWidth: 140, height: 35 }}
            />
          </Grid>
        </Grid>
      </Paper>

      {billableIntents ? (
        <Paper style={{ height: 700 }}>
          <DataGrid
            rows={filteredbillableIntents}
            columns={columns}
            pageSize={10}
            checkboxSelection={false}
            rowHeight={40}
            sortModel={[{ field: "psychologistSurname", sort: "asc" }]}
          />
        </Paper>
      ) : (
        "None"
      )}

      <Modal show={showClients} onHide={handleClientsClose} dialogClassName="editBilling-modal">
        <Modal.Header closeButton className="editBilling-modal">
          <Modal.Title>Nth QLD PHN Bookings - {providerName} </Modal.Title>
        </Modal.Header>
        <Modal.Body className="editBilling-modal">
          <GatherBillableDetail
            billablestatus={filters.invoiceStatus}
            approvalstatus={filters.approvalStatus}
            clients={providerClients}
            psychologistID={psychologistID}
            closeClients={setShowClients}
            displayNote={true}
          />
        </Modal.Body>
        <Modal.Footer className="editBilling-modal">
          <Button variant="secondary" onClick={handleClientsClose}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      <ToastContainer
        position="bottom-right"
        transition={Flip}
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}
